import { defineComponent as _defineComponent } from 'vue';
import { onMounted, onUnmounted } from 'vue';
import { useI18n } from 'vue-i18n';
import { CollapsibleRoot, CollapsibleTrigger, CollapsibleContent, DropdownMenuRoot, DropdownMenuTrigger, DropdownMenuPortal, DropdownMenuContent, } from 'reka-ui';
import EnDashboardIconWrapper from 'Components/icons/EnDashboardIconWrapper.vue';
import EnBetaBadge from 'Components/badge/EnBetaBadge/EnBetaBadge.vue';
import { ChevronDown } from 'lucide-vue-next';
import { NavigationIcons } from 'Components/icons/navigation/enIcons';
import { EnDashboardIconVariants } from 'Components/icons/EnDashboardIconVariants';
import EnSidebar, { SidebarGroup, SidebarGroupContent, SidebarGroupLabel, SidebarMenu, SidebarMenuButton, SidebarMenuItem, SidebarMenuSkeleton, SidebarMenuSub, SidebarMenuSubButton, SidebarMenuSubItem, } from 'Components/base/EnSidebar';
import useModuleNavigation from '../utils/useModuleNavigation';
import useNavigationData from '../utils/useNavigationData';
export default /*@__PURE__*/ _defineComponent({
    __name: 'EnNavigationArea',
    props: {
        rail: { type: Boolean, required: true },
        buildUrl: { type: Function, required: true },
        currentEnpowerAccount: { type: [String, Number, Object, null], required: false },
        buildId: { type: Function, required: false }
    },
    emits: ['update-recently-viewed-list'],
    setup(__props, { expose: __expose, emit: __emit }) {
        __expose();
        const { t } = useI18n();
        const props = __props;
        const emit = __emit;
        const { moduleGroups, openedEntryMap, expandedChildGroups, loadFromGlobal, loadFromCache, displayName, moduleUrl, moduleId, hasContent, truncatedDisplayName, shouldTruncate, onClick, groupKey, childKey, isChildExpanded, toggleChild, subgroupIcon, groupIcon, isModuleActive: isModuleActiveFromData, tryNavigateTo, } = useNavigationData(props, emit, t);
        const isModuleActive = (module) => isModuleActiveFromData(module);
        const isSubGroupChildActive = (subGroup) => Array.isArray(subGroup?.ModuleConfigs) && subGroup.ModuleConfigs.some((m) => isModuleActive(m));
        const navigationServices = useModuleNavigation({
            moduleGroups,
            expandedChildGroups,
            displayName,
            childKey,
            groupKey,
            subgroupIcon,
            groupIcon,
            isModuleActive,
        });
        const saveExpandedState = () => navigationServices.saveExpandedState();
        const buildRailEntries = (group) => navigationServices.buildRailEntries(group);
        function handleToggleChild(group, subGroup) {
            const currentKey = childKey(groupKey(group), subGroup);
            // if the clicked one is already open -> just close it
            if (isChildExpanded(currentKey)) {
                toggleChild(currentKey);
                return;
            }
            // close any other opened subgroup under the SAME parent group
            const siblings = Array.isArray(group?.ModuleConfigGroups) ? group.ModuleConfigGroups : [];
            for (const siblingSubGroup of siblings) {
                const siblingKey = childKey(groupKey(group), siblingSubGroup);
                if (siblingKey !== currentKey && isChildExpanded(siblingKey)) {
                    toggleChild(siblingKey);
                }
            }
            // open the clicked subgroup
            toggleChild(currentKey);
        }
        function navigateHandler(event, module, parent) {
            const url = moduleUrl(module);
            event?.preventDefault();
            // Emit recently viewed before navigation
            try {
                onClick(module, parent);
            }
            catch (e) {
                console.error('Error emitting recently viewed:', e);
            }
            saveExpandedState();
            tryNavigateTo(url);
        }
        onMounted(() => {
            try {
                const loaded = loadFromGlobal();
                if (!loaded)
                    loadFromCache();
                navigationServices.restoreExpandedState();
                navigationServices.expandToActive();
                navigationServices.setupHistoryListeners();
            }
            catch (e) {
                console.error('Error during navigation area mount initialization:', e);
            }
        });
        onUnmounted(() => {
            navigationServices.teardownHistoryListeners();
        });
        const __returned__ = { t, props, emit, moduleGroups, openedEntryMap, expandedChildGroups, loadFromGlobal, loadFromCache, displayName, moduleUrl, moduleId, hasContent, truncatedDisplayName, shouldTruncate, onClick, groupKey, childKey, isChildExpanded, toggleChild, subgroupIcon, groupIcon, isModuleActiveFromData, tryNavigateTo, isModuleActive, isSubGroupChildActive, navigationServices, saveExpandedState, buildRailEntries, handleToggleChild, navigateHandler, get CollapsibleRoot() { return CollapsibleRoot; }, get CollapsibleTrigger() { return CollapsibleTrigger; }, get CollapsibleContent() { return CollapsibleContent; }, get DropdownMenuRoot() { return DropdownMenuRoot; }, get DropdownMenuTrigger() { return DropdownMenuTrigger; }, get DropdownMenuPortal() { return DropdownMenuPortal; }, get DropdownMenuContent() { return DropdownMenuContent; }, EnDashboardIconWrapper, EnBetaBadge, get ChevronDown() { return ChevronDown; }, get NavigationIcons() { return NavigationIcons; }, get EnDashboardIconVariants() { return EnDashboardIconVariants; }, get EnSidebar() { return EnSidebar; }, get SidebarGroup() { return SidebarGroup; }, get SidebarGroupContent() { return SidebarGroupContent; }, get SidebarGroupLabel() { return SidebarGroupLabel; }, get SidebarMenu() { return SidebarMenu; }, get SidebarMenuButton() { return SidebarMenuButton; }, get SidebarMenuItem() { return SidebarMenuItem; }, get SidebarMenuSkeleton() { return SidebarMenuSkeleton; }, get SidebarMenuSub() { return SidebarMenuSub; }, get SidebarMenuSubButton() { return SidebarMenuSubButton; }, get SidebarMenuSubItem() { return SidebarMenuSubItem; } };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
